import React from 'react';

import { brandIcons } from '../../../config/branding';
import { AvailableGuestChargingHistory } from '../../../interface/guest-charging.interface';
import { useAppSelector } from '../../../redux/hooks';
import CustomTable from '../../../shared-components/custom-table/CustomTable';
/**
 * filter
 * @returns
 */
function GuestChargingHistory() {
  const { guestChargingHistory } = useAppSelector((state) => state.guestCharging);
  const column = [
    {
      label: 'S. No',
      accessorKey: 's_no' as keyof AvailableGuestChargingHistory,
      /**
       * S.No view
       * @param station
       * @param index
       */
      customData: (station: AvailableGuestChargingHistory, index: number) => (
        <div className="table-row-each-data" style={{ alignSelf: 'center' }}>
          {index + 1}
        </div>
      ),
      columnWidth: 50,
    },
    {
      label: 'Station',
      accessorKey: 'stationName' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'Facility',
      accessorKey: 'facility' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'Device',
      accessorKey: 'chargingPointSn' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'Date',
      accessorKey: 'date' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'Start Time',
      accessorKey: 'transactionStartsAt' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'End Time',
      accessorKey: 'transactionEndsAt' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'Duration',
      accessorKey: 'duration' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'Unit Consumed',
      accessorKey: 'powerConsumed' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: 'Cost',
      accessorKey: 'cost' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
      customLabel: <div className="currency-icon"><brandIcons.dollarCurrency /> Cost</div>
    },
  ];
  return (
    <div className="guest-charging-view">
      <CustomTable
        header={column}
        data={guestChargingHistory}
        currentPage={0}
        handlePageChange={() => {}}
        handleLimitChange={() => {}}
        topHeader={false}
      />
    </div>
  );
}

GuestChargingHistory.defaultProps = {
  rowId: '',
};

export default GuestChargingHistory;
